import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  //Used to scroll to top of page on rout change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
